import Vue from 'vue'
import ElementUI from 'element-ui';
import 'normalize.css/normalize.css';
import '@/assets/css/index.scss';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false
Vue.use(ElementUI)

import animated from 'animate.css'
Vue.use(animated)

import { WOW } from 'wowjs'

import xhr from '@/service/xhr'
import api from '@/service/api'
Vue.prototype.$xhr = xhr;
Vue.prototype.$api = api;

Vue.prototype.$wow = new WOW({
  animateClass: 'animate__animated'
})


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
